export default __webpack_public_path__ + "static/media/logo.c65effc4.png";